<template>
  <button class="btn btn-sm btn-outline-gray mr-1 mb-1" :disabled="busy" @click="onClick">
    <b-spinner v-if="busy" small variant="primary"></b-spinner>
    <i v-if="!busy" class="fa fa-ban"></i>
    <slot>Từ chối</slot>
  </button>
</template>

<script>
export default {
  props: {
    benhNhan: {
      type: Object,
    },
  },
  data() {
    return {
      busy: false,
    };
  },
  methods: {
    async onClick() {
      const { isConfirmed } = await this.showDialogConfirm();
      if (!isConfirmed) return;
      try {
        this.busy = true;
        const response = await this.$service.post(`/benh-nhan/review-unfollow-request/${this.benhNhan._id}/reject`);
        if (!response.data) throw new Error('Thất bại');
        this.showAlertSuccess();
      } catch (error) {
        this.showAlertFailed();
      } finally {
        this.busy = false;
        this.$bus.$emit('reloadBenhNhanList');
      }
    },

    showDialogConfirm() {
      return this.$swal({
        showCancelButton: true,
        title: "Bạn có chắc muốn từ chối đề xuất ngừng theo dõi bệnh nhân này?",
        icon: "question",
        confirmButtonText: "Tiến hành",
        cancelButtonText: "Hủy",
      })
    },

    showAlertSuccess() {
      this.$swal({
        title: this.$t('success'),
        text: 'Từ chối đề xuất ngừng theo dõi bệnh nhân thành công',
        icon: 'success',
      });
    },

    showAlertFailed() {
      this.$swal({
        title: this.$t('error'),
        text: 'Từ chối đề xuất ngừng theo dõi bệnh nhân thất bại',
        icon: 'error',
      });
    },
  },
};
</script>
